import {Pressable, StyleSheet, TextStyle, View, ViewStyle} from 'react-native';
import React from 'react';
import {Text} from 'ui-kits';
import colors from 'theme/Colors';
import {corner_radius, spacing} from 'theme/Units';

type propType = Readonly<{
  onQuickAdd: () => void;
  onAddWithDetails: () => void;
}>;
export function AddUserStoryDropDown(props: propType) {
  const {onAddWithDetails, onQuickAdd} = props;
  return (
    <View style={styles.container}>
      <Pressable onPress={onQuickAdd} style={styles.bottomBar}>
        <Text style={styles.text}>Quick Add +</Text>
      </Pressable>
      <Pressable onPress={onAddWithDetails}>
        <Text style={styles.text}>Add With Details +</Text>
      </Pressable>
    </View>
  );
}

type styleType = {
  container: ViewStyle;
  text: TextStyle;
  bottomBar: ViewStyle;
};
const styles: styleType = StyleSheet.create({
  bottomBar: {
    borderBottomWidth: 1,
    borderColor: colors.palette.white,
  },
  container: {
    backgroundColor: colors.palette.brandBlue,
    position: 'absolute',
    top: '92%',
    width: '100%',
    paddingVertical: spacing['2'],
    paddingHorizontal: spacing['4'],
    gap: spacing['2'],
    borderRadius: corner_radius['rounded-md'],
  },
  text: {
    color: colors.palette.white,
    paddingVertical: spacing['1'],
    fontSize: 13,
    fontWeight: 700,
    flexWrap: 'nowrap',
  },
});
